import { StarIcon } from "@heroicons/react/24/solid";
import React, { FC, useContext, useEffect, useState } from "react";
import Avatar from "./Avatar";
import CommentAvatar from "./CommentAvatar";
import ButtonThird from "shared/Button/ButtonThird";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { requestAPI } from "utils/api";
import { GlobalDataContext } from "contexts/GlobalData";
import GuestAvatar from "assets/images/guest.png";
import { useParams } from "react-router-dom";
import { UIContext } from "contexts/UIContext";

const CommentListing = ({
	className,
	data,
	date,
	load
}: any) => {

	const { id } = useParams();

	const { 
		initData
	} = useContext (GlobalDataContext);

	const {
		toast,
	} = useContext(UIContext);  

	const self_id = initData.token_info.user_id;

	const [ isModify, setIsModify ] = useState <boolean> (false);
	const [ comment, setComment ] = useState <string> ("");

	useEffect (() => {
		setComment(data.comment);
	}, [data.comment]);


	const handleChange = async (value: string) => {
		
		setComment(value);
	};

	const deleteRequest = async () => {

		const res: any = await requestAPI ('DELETE', `v1/comment/product/${data._id}`, {
			product_no: id
		});		
		
		if (res.code === 1000) {
			toast ({
				type: 'success', 
				contents: "글이 삭제 되었어요"
			});

			load();
		}		
	};

	const handleModify = async () => {
		
		setIsModify(true);
	};

	const modifyRequest = async () => {
		
		const res: any = await requestAPI ('PUT', `v1/comment/product/${data._id}`, {
			commentContents: comment
		});		
		
		setIsModify(false);	

		if (res.code === 1000) {
			toast ({
				type: 'success', 
				contents: "글이 수정 되었어요"
			});
		}		
	};

	const url = (data.user_profileUrl === null)
  	? `${process.env.REACT_APP_SERVER_FILE}/static/avatar/guest.png`
	: `${process.env.REACT_APP_SERVER_FILE}/avatar/${data.user_profileUrl}`;


	return (
		<>
		{isModify === false
		?
			<div
				className={`nc-CommentListing ${className}`}
				data-nc-id="CommentListing"
			>
				<div className="flex space-x-4">
					<div className="pt-0.5">
						<CommentAvatar
							sizeClass="h-10 w-10 text-lg"
							radius="rounded-full"
							userName={data.user_displayName}
							imgUrl={url}
						/>
					</div>
					<div className="flex-grow">
						<div className="flex justify-between space-x-3">
							<div className="flex flex-col">
								<div className="text-sm font-semibold">
									<span>{data.user_displayName}</span>
								</div>
								<span className="text-sm text-neutral-500 dark:text-neutral-400 mt-0.5">
									{date}
								</span>
							</div>
						</div>
						<span className="block mt-3 text-neutral-6000 dark:text-neutral-300">
							{comment}
						</span>
						<div className="flex justify-between">
							<div></div>
							<div className="mr-4">
								{(self_id === data.user_id)
									?
									<>
										<div className="!space-x-2">
											<ButtonThird
												className="!m-0 !pl-4 !pr-4 !pt-2 !pb-2"
												onClick={() => deleteRequest()}
											>
												삭제
											</ButtonThird>
											<ButtonPrimary
												className="!m-0 !pl-4 !pr-4 !pt-2 !pb-2"
												onClick={() => handleModify()}
											>
												수정
											</ButtonPrimary>
										</div>
									</>
									:
									<></>
								}
							</div>
						</div>
					</div>
				</div>


				{data.reply === undefined || data.reply === null
				?
					<></>
				:
					<div className="ml-[56px] flex items-center">
						<div>
							<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.0} stroke="currentColor" className="size-4">
								<path strokeLinecap="round" strokeLinejoin="round" d="m16.49 12 3.75 3.75m0 0-3.75 3.75m3.75-3.75H3.74V4.499" />
							</svg>
						</div>
						<span className="ml-1 mr-1 mt-2 inline-flex items-center rounded-md bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700 ring-1 ring-inset ring-blue-700/10">
							답변
						</span>
						<span className="mt-2 block text-neutral-6000 dark:text-neutral-300">
							{data.reply}
						</span>
					</div>
				}
			</div>
		:
			<div className="flex items-start space-x-4">
				<div className="min-w-0 flex-1">
					<form action="#">
						<div className="border-b border-gray-200 focus-within:border-indigo-600">
							<label htmlFor="comment" className="sr-only">
								댓글 수정
							</label>
							<textarea
								id="comment"
								name="comment"
								rows={3}
								placeholder="Add your comment..."
								className="!rounded-lg block w-full resize-none border-0 border-b border-transparent p-0 pb-2 text-gray-900 placeholder:text-gray-400 focus:border-indigo-600 focus:ring-0 sm:text-sm/6"
								value={comment}
								onChange={e => handleChange(e.target.value)}
							/>
						</div>
						<div className="flex justify-between pt-2">
							<div className="flex items-center space-x-5">
								<div className="flow-root">
									
								</div>
								<div className="flow-root">
									
								</div>
							</div>
							<div className="shrink-0">
								<button
									type="button"
									className="inline-flex items-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
									onClick={e => modifyRequest()}
								>
									전송
								</button>
							</div>
						</div>
					</form>
				</div>
			</div>
		}
		</>
	);
};

export default CommentListing;
